import React from "react";
import { Form } from "react-bootstrap";
import { Field } from "formik";

const FormSelectField = ({ name, type, children, setFieldValue }) => {
  return (
    <Field
      className="select"
      name={name}
      render={({ field, form }) => {
        return (
          <Form.Control
            onChange={(selectedOption) => {
              setFieldValue(name, selectedOption);
            }}
            {...field}
            type={type}
            as="select"
          >
            {children}
          </Form.Control>
        );
      }}
    />
  );
};

FormSelectField.defaultProps = {
  type: "select",
  inputGroupPrepend: null,
};

export default FormSelectField;
